import HeaderRenderer from './HeaderRenderer/HeaderRenderer';
import headerRootQuery, {
    initialVariables as headerInitialVariables,
} from '../queries/headerRootQuery';

export { HeaderRenderer, headerRootQuery, headerInitialVariables };
